// extracted by mini-css-extract-plugin
export var deliveryRow = "_nx-a";
export var fixedHeight = "_nx-4";
export var freightLogo = "_nx-9";
export var fullWidth = "_nx-3";
export var priceColumn = "_nx-5";
export var radioSelected = "_nx-7";
export var radioUnselected = "_nx-6";
export var selectedOption = "_nx-2";
export var selectedOptionContainer = "_nx-1";
export var selection = "_nx-0";
export var tallSkeletonText = "_nx-8";